<mat-card>
    <mat-card-header>
        <mat-card-title>
            Resolve CALPADS SSIDs

        </mat-card-title>
    </mat-card-header>

    <div *ngIf="this.isLoading">
        <mat-spinner></mat-spinner>
    </div>
    <app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>

    <div *ngIf="results.length > 0 && !this.isLoading" class="margin-top-md table-responsive">


        <mat-table [dataSource]="tableDataSource" matSort class="mat-elevation-z8 demo-table">

            <ng-container matColumnDef="Region">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:70px;">
                    Region
                </mat-header-cell>
                <mat-cell *matCellDef="let element"> {{element.CODE}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Unresolved">
                <mat-header-cell *matHeaderCellDef mat-sort-header style="min-width:90px;">
                    Unresolved (To Do)
                </mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="{'clickable': element.UNRESOLVED_COUNT > 0}"
                    (click)="navigateToUnresolved(element.CODE, element.UNRESOLVED_COUNT)">
                    {{element.UNRESOLVED_COUNT}}

                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Resolved">
                <mat-header-cell *matHeaderCellDef mat-sort-header> Resolved (Done - Includes automated & manual
                    matches) </mat-header-cell>
                <mat-cell *matCellDef="let element" [ngClass]="{'clickable': element.RESOLVED_COUNT> 0}"
                    (click)="navigateToResolved(element.CODE, element.RESOLVED_COUNT)">
                    {{element.RESOLVED_COUNT}}
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
        </mat-table>

    </div>    
</mat-card>